var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGf = function SvgGf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#078930",
    d: "M0 0h640v480z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M0 0l640 480H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M252.37 218.025h135.26L278.203 297.53 320 168.89l41.798 128.64z"
  })));
};
export default __webpack_public_path__ + "assets/e129304536db0081bd540a64a66a15dc.svg";
export { SvgGf as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gf.svg